<template>
  <div class="p-2">
    <table class="mb-3">
      <tr>
        <td class="text-left">Titel:</td>
        <td class="text-left"><TimeTrackingTextfield v-model="newTitle" /></td>
      </tr>
      <tr>
        <td class="text-left">Beschreibung:</td>
        <td class="text-left"><TimeTrackingTextfield v-model="newDescription" /></td>
      </tr>
      <tr>
        <td class="text-left">Fertig bis:</td>
        <td class="text-left"><input class="border-black border-1 w-48 pl-1" type="datetime-local" v-model="newFinishedUntil"></td>
      </tr>
      <tr>
        <td class="text-left">Flag Type:</td>
        <td class="flex flex-row gap-1">
          <TimeTrackingRadiobox v-model="selectedNewFlag" class="border-gray-300 border-1 " :id="flag.id" :value="flag.name" :key="flag.id" v-for="flag of getFlagTypes">
            <TodoFlag  :flagText="flag.name"></TodoFlag>
          </TimeTrackingRadiobox></td>
      </tr>
      <!-- <tr>
        <td colspan="2"><hr/></td>
      </tr>
      <tr>
        <td></td>
        <td>
          selectedNewFlag: {{ selectedNewFlag }}<br>
          {{ getFlagTypes }}<br>
          newTitle: {{ newTitle }}<br>
          newDescription: {{ newDescription }}<br>
        </td>
      </tr>
      <tr>
        <td colspan="2"><hr/></td>
      </tr> -->
      <tr>
        <td>
          <TimeTrackingButton
          iconText="plusCircle"
          :disabled="newTitle == ''"
          @onButtonClick="onNewEntry"
          />
        </td>
        <td></td>
      </tr>
    </table>

    <div v-if="getUserTodos.length == 0">Keine Daten</div>
    <div v-for="entry of getUserTodos" :key="entry.id" class="border-black border-1 flex flex-wrap items-center my-2 p-1 gap-2">
      <TimeTrackingCheckbox v-model="entry.closed" />
      <TodoFlag  :flagText="getFlagTypeById(entry.flagTypeId)"></TodoFlag>
      <!-- {{ entry.id }} -->
      <TimeTrackingTextfield v-model="entry.title" />
      <TimeTrackingButton :big-button="false" iconText="contentSave" @onButtonClick="onSaveEntry(entry.id)"/>

      <button
        :class="
          forDeleteEntry == null || forDeleteEntry != entry.id
            ? 'hover:bg-blue-700 bg-blue-500'
            : 'hover:bg-red-700 bg-red-500'
        "
        class="text-white font-bold py-0 px-2 rounded"
        @click="onDeleteTodoEntryClick(entry.id)"
        @blur="forDeleteEntry = null"
      >
        <IconSelector :iconText="'trashCanOutline'" />
      </button>
      <div>Erstellt: {{ dateAndTimeString(entry.createdAt) }}</div>
      <div>Fertig bis: {{ dateAndTimeString(entry.finishedUntil) }}</div>
    </div>
    <!-- <pre>
      {{ getUserTodos }}
    </pre> -->
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex"
import TimeTrackingButton from "./guiComponents/TimeTrackingButton.vue"
import TimeTrackingCheckbox from "./guiComponents/TimeTrackingCheckbox.vue"
import TimeTrackingTextfield from "./guiComponents/TimeTrackingTextfield.vue"
import IconSelector from "./combinedIcons/IconSelector.vue"
import TodoFlag from "./guiComponents/TodoFlag.vue"
import TimeTrackingRadiobox from "./guiComponents/TimeTrackingRadiobox.vue"

export default {
  name: "TodoList",
  components: {
    IconSelector,
    TimeTrackingButton,
    TimeTrackingCheckbox,
    TimeTrackingTextfield,
    TodoFlag,
    TimeTrackingRadiobox,
  },
  data() {
    return {
      forDeleteEntry: null,
      selectedNewFlag: 'none',
      newTitle: '',
      newDescription: '',
      newFinishedUntil: null,
    }
  },
  computed: {
    ...mapGetters("auth", {
      gettersAuthData: "getAuthData",
    }),
    ...mapGetters("users", {
      userData: "userData",
    }),
    ...mapGetters("todolist", {
      getFlagTypes: "getFlagTypes",
      getUserTodos: "getUserTodos",
    }),
    sortedUserTodos() {
      return this.getUserTodos
    }
  },
  created() {
    this.fetchUserData()
    this.callListFlagTypes()
    this.callListUserTodos()
  },
  methods: {
    ...mapActions("users", {
      getUserData: "getUserData",
    }),
    ...mapActions("todolist", {
      createTodoEntry: "createTodoEntry",
      updateTodoEntry: "updateTodoEntry",
      deleteTodoEntry: "deleteTodoEntry",
      listUserTodos: "listUserTodos",
      listFlagTypes: "listFlagTypes",
    }),
    onListUserTodosClick(_ev) {
      console.log('onListUserTodosClick', _ev)
      this.listUserTodos({
        userId: this.userData.id,
      })
    },
    onSaveEntry(entryId) {
      console.log('entryId', entryId)
      console.log('entryDate:', this.getUserTodos.find(e => e.id == entryId))
      this.updateTodoEntry(
        {
          userId: this.userData.id,
          ...this.getUserTodos.find(e => e.id == entryId)
        }
      )
    },
    onNewEntry() {
      const dataForSend = {
        userId: this.userData.id,
        flagTypeId: this.getFlagTypes.find(e => e.name == this.selectedNewFlag).id,
        title: this.newTitle,
        description: this.newDescription,
        finishedUntil: this.newFinishedUntil,
      }
      this.createTodoEntry(dataForSend)
      this.selectedNewFlag = 'none'
      this.newTitle = ''
      this.newDescription = ''
      this.newFinishedUntil = null
    },
    async onDeleteTodoEntryClick(entryId) {
      if (this.forDeleteEntry == null || this.forDeleteEntry != entryId) {
        this.forDeleteEntry = entryId
      } else {
        this.forDeleteEntry = null
        await this.deleteTodoEntry(
          {
            id: entryId,
            userId: this.userData.id,
          }
        )
      }
    },
    dateAndTimeString(dateString) {
      if (!dateString || dateString == '') {
        return '___'
      }
      const dateObj = new Date(dateString)

      return dateObj.toLocaleDateString() + ' ' + dateObj.toLocaleTimeString()
    },
    getFlagTypeById(flagTypeId) {
      const element = this.getFlagTypes.find(e => e.id == flagTypeId)
      if (element == null) {
        return 'none'
      } else {
        return element.name
      }
    },
    async fetchUserData() {
      await this.getUserData({ userId: this.gettersAuthData.userId })
    },
    async callListFlagTypes() {
      await this.listFlagTypes()
    },
    async callListUserTodos() {
      await this.listUserTodos({ userId: this.gettersAuthData.userId })
    },
  },
}
</script>
